// extracted by mini-css-extract-plugin
export default {"form-group":"Input_form-group__E70A-","input":"Input_input__4tbQ4"};